import { Component } from '@angular/core';

@Component({
  selector: 'webapp-compat-navigation-secondary-community',
  template: `
    <app-navigation-secondary-community></app-navigation-secondary-community>
    <router-outlet></router-outlet>
  `,
})
export class CompatNavigationSecondaryCommunityComponent {}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/pl/webapp/src/compat/compat-navigation-secondary-community.component.ts